export var SMALL_WIDTH = 25;
export var BIG_WIDTH = 40;
export var SMALL_WIDTH_PADDING = 16;
export var BIG_WIDTH_PADDING = 24;
//# sourceMappingURL=constants.js.map